
(() => {
  function hideVideoControls(root = document) {
    const videos = [];

    if (root instanceof HTMLVideoElement) {
      videos.push(root);
    }

    if (root.querySelectorAll) {
      videos.push(...root.querySelectorAll(
        "deferred-media video"
      ));
    }

    videos.forEach(video => {
      video.controls = false;
      video.removeAttribute("controls");
      video.disablePictureInPicture = true;
      video.setAttribute("controlslist", "nodownload nofullscreen noremoteplayback");
    });
  }

  // Run on initial load
  hideVideoControls();

  // Run after page loads
  document.addEventListener("DOMContentLoaded", () => {
    hideVideoControls();
  });

  // Handle Shopify Theme Editor updates
  document.addEventListener("shopify:section:load", event => {
    hideVideoControls(event.target);
  });

  // Handle dynamically loaded videos
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.type === "attributes") {
        hideVideoControls(mutation.target);
      }

      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          hideVideoControls(node);
        }
      });
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["controls"]
  });
})();
